import { HeaderWithNextButton } from "@components";
import { GeneralInfoForm } from "./components";

import { useProcurement } from "@hooks/procurements/procurement/useProcurement";

import { ProcurementResponseType } from "@type/procurements/procurement";

export interface GeneralInfoPropsType {
  id: any; //!!!
  setSearchParams: Function;
  changeActiveTab: (arg: number) => void;
}

const GeneralInfo = ({
  id,
  changeActiveTab,
  setSearchParams,
}: GeneralInfoPropsType) => {
  const { procurementState } = useProcurement();
  const { getSingleData } = procurementState;

  return (
    <div className="p-10">
      <HeaderWithNextButton
        title="PROCUREMENT_CREATE.TABS.GENERAL_INFO"
        isDisabled={!id}
        action={() => changeActiveTab(1)}
      />
      <GeneralInfoForm
        id={id}
        procurement={id ? (getSingleData as ProcurementResponseType) : null}
        changeActiveTab={changeActiveTab}
        setSearchParams={setSearchParams}
      />
    </div>
  );
};

export default GeneralInfo;
